import { Link } from 'react-router-dom';

export default function AuthLink({ children, ...rest }) {
  return <Link className="auth__link align-self-center" {...rest}>
    {children}
  </Link>
}
